const typographyFormParamFreq = {
  true: 'Nueva Periodicidad',
  false: 'Editar Periodicidad'
};

export default typographyFormParamFreq;
